import { pathJoin } from 'src/reducers/routing/utils'

export const createScpDetailViewRouteMap = (prefix: string) => ({
  overview: pathJoin(prefix)('overview').chain,
  map: pathJoin(prefix)('map').chain,
  containers: pathJoin(prefix)('containers').chain,
  'collection-log': pathJoin(prefix)('collection-log').chain,
  history: pathJoin(prefix)('history').chain,
  tickets: pathJoin(prefix)('tickets').chain,
  invoices: pathJoin(prefix)('invoices').chain,
})
